import { css, html } from 'react-strict-dom';
import { GoalRing, Text } from 'src/components';
import { Color, Style } from 'src/constants';
import { color } from 'src/constants/color.css';
import { Model } from 'src/models';
import { formatTimeSpent } from 'src/util';

type Props = {
  minutes: number;
};

export default function TimeLoggedBanner({ minutes }: Props) {
  const timeSpent = formatTimeSpent(minutes);
  const remaining = Model.DailyTask.getGoalRemaining(minutes);

  return (
    <html.div style={[Style.row, Style.alignCenter, styles.banner]}>
      <GoalRing
        progress={Model.DailyTask.getGoalProgress(minutes)}
        size={44}
        thickness={5}
        trackColor={Color.neutral0}
      />
      <html.div style={Style.col}>
        <Text typeface="body.medium" color="neutral100">
          {timeSpent
            ? `${timeSpent} spent on tickets today`
            : 'No time logged on tickets yet today'}
        </Text>
        <Text typeface="body.small.regular" color="neutral60">
          {remaining === 0
            ? "You're on track 💪"
            : `${formatTimeSpent(remaining)} to go`}
        </Text>
      </html.div>
    </html.div>
  );
}

const styles = css.create({
  banner: {
    gap: 16,
    backgroundColor: color.blueBg,
    borderRadius: 12,
    paddingBlock: 16,
    paddingInline: 20,
  },
});
